import styled from '@emotion/styled';
import { PublicRounded, SearchRounded } from '@mui/icons-material';

interface LiveTvFiltersProps {
  search: string;
  selectedCountry: string;
  countries: string[];
  onSearchChange: (value: string) => void;
  onCountryChange: (value: string) => void;
}

export default function LiveTvFilters({
  search,
  selectedCountry,
  countries,
  onSearchChange,
  onCountryChange,
}: LiveTvFiltersProps) {
  return (
    <FilterBar>
      <Field>
        <SearchRounded aria-hidden="true" />
        <Input
          type="search"
          aria-label="Search channels"
          placeholder="Search channels..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </Field>

      <Field>
        <PublicRounded aria-hidden="true" />
        <Select
          aria-label="Filter channels by country"
          value={selectedCountry}
          onChange={(e) => onCountryChange(e.target.value)}>
          <option value="">All countries</option>
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </Select>
      </Field>
    </FilterBar>
  );
}

const FilterBar = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);
  gap: 12px;
  margin-bottom: 18px;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`;

const Field = styled.label`
  min-height: 52px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  border: 1px solid var(--walky-border);
  border-radius: 8px;
  background: var(--walky-surface);
  color: var(--walky-muted);
  box-shadow: 0 6px 18px rgba(24, 24, 27, 0.06);
  transition:
    border-color 160ms ease,
    box-shadow 160ms ease;

  &:focus-within {
    border-color: var(--walky-orange);
    box-shadow: 0 0 0 3px var(--walky-orange-soft);
  }

  svg {
    width: 21px;
    height: 21px;
    color: var(--walky-orange);
    flex: 0 0 auto;
  }
`;

const Input = styled.input`
  width: 100%;
  min-width: 0;
  min-height: 52px;
  border: 0;
  background: transparent;
  color: var(--walky-ink);
  outline: none;
  font-size: 15px;
  line-height: 1.2;

  &::placeholder {
    color: var(--walky-muted);
  }
`;

const Select = styled.select`
  width: 100%;
  min-width: 0;
  min-height: 52px;
  border: 0;
  background: transparent;
  color: var(--walky-ink);
  color-scheme: light;
  outline: none;
  font-size: 15px;
  line-height: 1.2;
  cursor: pointer;

  [data-walky-theme='dark'] & {
    color-scheme: dark;
  }

  option {
    background-color: var(--walky-surface);
    color: var(--walky-ink);
  }

  option:checked {
    background-color: var(--walky-orange);
    color: #ffffff;
  }
`;
